<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'LanguageLabel',

    functional: true,

    props: {
        languages: {type: [Object, Array], default: null},
        hideName: {type: Boolean},
        none: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        const nullLabel = props.none || parent.$t('common.labels.language.nil');

        if (Array.isArray(props.languages)) {
            const hideName = props.hideName || (props.languages.length > 1);

            return createElement('span', data, props.languages
                .map((language, index) => createElement('LanguageLabel', {
                    key: language ? language.id : ('language-' + index),
                    props: {
                        languages: language,
                        hideName: hideName,
                        none: nullLabel,
                    },
                })));
        }

        const language = props.languages;

        const iconClass = language
            ? `flag-icon flag-icon-${language.flag}`
            : 'far fa-fw fa-flag';

        data.props = {
            item: props.hideName ? '' : language,
            iconClass: iconClass,
            none: nullLabel,
        };

        if (props.hideName || !language) {
            data.attrs = {
                ...data.attrs,
                title: language ? language.name : nullLabel,
            };
            data.directives = [{name: 'tooltip'}].concat(data.directives || []);
        }

        return createElement(DataLabel, data);
    },
};
</script>
